import { brand } from '../../../theme/themePrimitives';
import CardWrapper from '../../wrapper/card';
import { DealObject } from '../../../params/pipeline';
import DeleteDealModal from '../../deal/modal/delete_deal';
import ImageClass from '../../../assets';
import { useNavigate } from 'react-router';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../../redux/store';
import { Avatar, Box, CardContent, Grid, IconButton, Typography } from '@mui/material';
import { Delete, Edit, EmailOutlined, PhoneOutlined, Visibility } from '@mui/icons-material';
import { setEditDeal, settingSelectedDeal, settingViewDetail } from '../../../redux/slices/deal';
import { useDispatch, useSelector } from 'react-redux';

interface RoloDexCardProps {
    search: string;
    sort: boolean;
}

const RoloDexCard = ({ search, sort }: RoloDexCardProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { deals } = useSelector((state: RootState) => state.deal);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

    // **Filter and Sort Logic**
    const filteredDeals = deals.filter((deal: DealObject) => {
        const company = deal.company?.toLowerCase() || '';
        const email = deal.email?.toLowerCase() || '';
        const phone = deal.phone || '';
        return (
            !search ||
            company.includes(search.toLowerCase()) ||
            email.includes(search.toLowerCase()) ||
            phone.includes(search)
        );
    });

    // Sort deals alphabetically by company name if `sort` is true
    const sortedDeals: DealObject[] = sort
        ? [...filteredDeals].sort((a, b) => a.company.localeCompare(b.company))
        : filteredDeals;

    const handleViewSelection = (value: DealObject) => {
        dispatch(settingSelectedDeal(value));
        dispatch(settingViewDetail(true));
        dispatch(setEditDeal(false));
        navigate('/app/deals');
    };

    const handleDeleteSelection = (value: DealObject) => {
        dispatch(settingSelectedDeal(value));
        setShowDeleteModal(true);
    };

    const editDealHandler = (value: DealObject) => {
        dispatch(settingSelectedDeal(value));
        dispatch(setEditDeal(true));
        navigate('/app/deals');
    };
    return <Grid container spacing={3}>
        {sortedDeals.map((row) => (
            <Grid item xs={12} sm={6} md={4} key={row.id}>
                <CardWrapper>
                    <CardContent>
                        <Box display="flex" justifyContent="space-between" alignItems="start" mb={2}>
                            <Box display="flex" alignItems="center">
                                <Avatar
                                    src={ImageClass.userImage}
                                    alt="User"
                                    sx={{
                                        height: '80px',
                                        width: '80px',
                                        marginRight: '20px',
                                        border: `1px solid ${brand[300]}`
                                    }}
                                />
                                <Typography variant="h6">{row.company}</Typography>
                            </Box>
                            <Box display="flex" alignItems="center" gap="2px">
                                <IconButton onClick={() => handleViewSelection(row)}>
                                    <Visibility fontSize="small" color="info" />
                                </IconButton>
                                <IconButton onClick={() => editDealHandler(row)}>
                                    <Edit fontSize="small" color="info" />
                                </IconButton>
                                <IconButton onClick={() => handleDeleteSelection(row)}>
                                    <Delete fontSize="small" color="error" />
                                </IconButton>
                            </Box>
                        </Box>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Box display="flex" alignItems="center" gap="5px"><EmailOutlined fontSize="small" /><Typography variant="body2">{row.email}</Typography></Box>
                            <Box display="flex" alignItems="center" gap="5px"><PhoneOutlined fontSize="small" /><Typography variant="body2">{row.phone}</Typography></Box>
                        </Box>
                    </CardContent>
                </CardWrapper>
            </Grid>
        ))}
        {showDeleteModal && <DeleteDealModal open={showDeleteModal} onClose={() => setShowDeleteModal(false)} />}
    </Grid>;
};

export default RoloDexCard;